import { IConditionContext } from "./Interfaces/IConditionContext";
import { Condition } from "../../../Pages/Measure/VisibilityDependency/Condition";
import { IDropdown } from "../../Interfaces/IDropdown";
import { ITreeField } from "../../../Frame/GridViewSelect/ITreeField";
import { DropDownComponentProps, DropDownComponent } from "../../DropDownComponent";
import { app } from "../../../Frame/App";
import { TemplateConditionContext } from "./TemplateConditionContext";
import { TemplateFieldTypes } from "../../../Areas/Admin/Shared/Models/TemplateFieldTypes";
import { DynamicFieldControlType } from "../../../Controls/Dynamic/DynamicFieldControlType";
import { FieldHelper } from "../../../Common/FieldHelper";
import { Template } from "../../../Areas/Admin/Measures/TemplateEdit/Models/Template";
import { IFieldAndValueModel } from "../../../Pages/Measure/VisibilityDependency/IFieldAndValueModel";

export class GridViewConditionContext implements IConditionContext {
    constructor(private model: Condition, private availableFields: ITreeField) {}

    dropdown: IDropdown;

    getFieldControl(): IDropdown {
        let dropdownProps: DropDownComponentProps = {
            id: app.createRadomizedLetters(10),
            displayProperty: "name",
            valueProperty: "fieldName",
            childrenProperty: "childs",
            expandAll: false,
            items: this.availableFields.childs,
            onChange: this.onChange,
            disableSort: true,
            name: Resources.Common.field
        }
        this.dropdown = new DropDownComponent(dropdownProps);
        return this.dropdown;
    }

    private onChange = (control: DropDownComponent) => {
        this.model.fieldName = control.getValue();
    }

    selectedFieldExists(): boolean {
        for (let child of this.availableFields.childs) {
            if (child.childs) {
                for (let field of child.childs) {
                    if (field.fieldName == this.model.fieldName) {
                        return true;
                    }
                    if (field.childs) {
                        for (let block of field.childs) {
                            if (block.childs) {
                                for (let blockField of block.childs) {
                                    if (blockField.fieldName == this.model.fieldName) {
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return false;
    }

    setField = (triggerOnChange: boolean = true): void => {
        this.dropdown.setValue(this.model.fieldName, triggerOnChange);
    }

    getSelectedCategoryID(field: any): number {
        let typedField = field as ITreeField;
        if (typedField.fieldName.indexOf("CAT") > -1) {
            let id: number;
            // Pattern: 'CAT#<id>'
            id = parseInt(typedField.fieldName.substring(4));
            return id;
        }
        throw new Error(`The field ${field.name} ist not a category field.`);
    }

    getSelectedLocalFieldID(field: any): number {
        let typedField = field as ITreeField;
        if (typedField.fieldName.indexOf("LF") > -1) {
            let id: number;
            // Pattern: 'LF#<id>'
            id = parseInt(typedField.fieldName.substring(3));
            return id;
        }
        throw new Error(`The field ${field.name} ist not a local field.`);
    }

    getStatusFromParentSourceUrl(field: any): string {
        let fieldId = this.getSelectedLocalFieldID(field);

        return `~/api/dynamic/getActivitaetParentStatus/${fieldId}`;
    }

    getOperators(fieldControl: IDropdown): { name: string; value: string; }[] {
        let field = fieldControl.getSelectedItem() as ITreeField;

        let operators: { name: string, value: string }[] = [];

        if (field.fieldName.startsWith("LF#")) {
            // TemplateField, instanciate the TemplateFieldContext
            let templateContext = new TemplateConditionContext(null, undefined, undefined);
            operators = templateContext.getOperatorsForFieldType(TemplateFieldTypes[field.valueType], true);

        } else if (field.fieldName.startsWith("CAT#")) {
            operators = [
                { name: Resources.Common.suchenIstGleich, value: "=" },
                { name: Resources.Common.suchenIstUngleich, value: "<>" },
                { name: Resources.Common.suchenIstNotNull, value: "not null" },
                { name: Resources.Common.suchenIstNull, value: "null" }
            ];

        } else {
            // TableField
            switch (DynamicFieldControlType[field.valueType]) {
                case DynamicFieldControlType.TextBox:
                case DynamicFieldControlType.RichText:
                case DynamicFieldControlType.MultiLine:
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "like" },
                        { name: Resources.Common.suchenIstUngleich, value: "not like" },
                        { name: Resources.Common.suchenBeginntMit, value: "left" },
                        { name: Resources.Common.suchenEnthaelt, value: "contains" },
                        { name: Resources.Common.suchenEnthaeltNicht, value: "not contains" },
                        { name: Resources.Common.suchenIstNull, value: "null" }
                    ];
                    break;
                case DynamicFieldControlType.Category:
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" },
                        { name: Resources.Common.suchenIstNotNull, value: "not null" },
                        { name: Resources.Common.suchenIstNull, value: "null" }
                    ];
                case DynamicFieldControlType.YesNo:
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" }
                    ];
                    break;
                case DynamicFieldControlType.Double:
                case DynamicFieldControlType.Int:
                    if (DynamicFieldControlType[field.valueType] == DynamicFieldControlType.Int &&
                        (field.fieldName == "EreignisId" || field.fieldName == "Ampel")) {
                        operators = [
                            { name: Resources.Common.suchenIstGleich, value: "=" },
                            { name: Resources.Common.suchenIstUngleich, value: "<>" }
                        ];
                    } else {
                        operators = [
                            { name: Resources.Common.suchenIstGleich, value: "=" },
                            { name: Resources.Common.suchenIstUngleich, value: "<>" },
                            { name: Resources.Common.suchenIstGroesser, value: ">" },
                            { name: Resources.Common.suchenIstKleiner, value: "<" },
                            { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                            { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                            { name: Resources.Common.suchenIstNull, value: "null" },
                        ];
                    }
                    break;
                case DynamicFieldControlType.DatePicker:
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" },
                        { name: Resources.Common.suchenIstGroesser, value: ">" },
                        { name: Resources.Common.suchenIstKleiner, value: "<" },
                        { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                        { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                        { name: Resources.Common.suchenIstNull, value: "null" },
                        { name: Resources.Common.dateFilterToday, value: "today" },
                        { name: Resources.Common.dateFilterTomorrow, value: "tomorrow" },
                    ];
                    break;
                case DynamicFieldControlType.MultiUser:
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" },
                        { name: Resources.Common.suchenIch, value: "me" }
                    ];
                case DynamicFieldControlType.UserList:
                    operators = [
                        { name: Resources.Common.suchenEnthaelt, value: "=" },
                        { name: Resources.Common.suchenEnthaeltNicht, value: "<>" },
                        { name: Resources.Common.suchenIstNull, value: "null" },
                        { name: Resources.Common.suchenIstNichtNull, value: "not null" },
                        { name: Resources.Common.suchenIch, value: "me" }
                    ];
                    break;
                default:
                    break;
            }
        }

        return operators;
    }

    getValueType(fieldControl: IDropdown) {
        let field = fieldControl.getSelectedItem() as ITreeField;
        return FieldHelper.getValueTypeByTreeField(field);
    }

    getCompareFieldControl(model: IFieldAndValueModel): IDropdown {
        return null;
    }
}